import React from 'react';
import styled from 'styled-components';
import { SchoolDTO } from '../SearchSchoolsSelect/useSearchSchoolsSelect';
import { formatCurrency } from '../../../../../../CommonUtils/formatNumber';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';

const Label = styled(Text).attrs({
  as: 'td',
  color: 'neutral.100',
  fontSize: 'small',
})``;

const Value = styled(Text).attrs({
  as: 'td',
  color: 'neutral.100',
  fontSize: 'small',
  fontWeight: 600,
  textAlign: 'right',
})``;

const Total = styled(Text).attrs({
  as: 'td',
  color: 'neutral.100',
  fontSize: 'small',
  fontWeight: 600,
})``;

interface Props {
  school: SchoolDTO;
  isInState: boolean;
  amount: number;
}

export const CostBreakdown = ({ school, isInState, amount }: Props) => {
  const { inStateTuition, outOfStateTuition, suppliesCost, housingCost, otherExpenses } = school;

  const getTuition = () => {
    if (isInState) {
      return inStateTuition ? formatCurrency(inStateTuition) : 'n/a';
    }

    return outOfStateTuition ? formatCurrency(outOfStateTuition) : 'n/a';
  };

  return (
    <table>
      <tbody>
        <tr>
          <Label>Tuition:</Label>
          <Value>{getTuition()}</Value>
        </tr>

        <tr>
          <Label>Book &amp; Supplies:</Label>
          <Value>{suppliesCost ? formatCurrency(suppliesCost) : 'n/a'}</Value>
        </tr>

        <tr>
          <Label>Room &amp; Board:</Label>
          <Value>{housingCost ? formatCurrency(housingCost) : 'n/a'}</Value>
        </tr>

        <tr>
          <Label>Other Expenses:</Label>
          <Value>{otherExpenses ? formatCurrency(otherExpenses) : 'n/a'}</Value>
        </tr>

        <tr>
          <Total>Estimated Total:</Total>
          <Value>{formatCurrency(amount)}</Value>
        </tr>
      </tbody>
    </table>
  );
};
